export default __webpack_public_path__ + "static/media/excel2.d47137b5.png";